module.exports = new __parcel__URL__("groups.9615f777.svg").toString();